import type { SVGProps } from "react";
import { cn } from "@/lib/utils";

const Vercel = (props: SVGProps<SVGSVGElement>) => {
  const { className, ...rest } = props;
  return (
    <svg
      className={cn(className)}
      height="1em"
      preserveAspectRatio="xMidYMid"
      viewBox="0 0 256 222"
      width="1em"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path d="m128 0 128 221.705H0z" fill="#000" />
    </svg>
  );
};
export default Vercel;
